import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import CONFIG from '../../config.js';
import CalendarioResumenEventos from '../mensajes/CalendarioResumenEventos.js';
import './Principal.css';

const URL_CALENDARIO = `${CONFIG.API_URL}/operarCalendario.php`;

function PrincipalPreceptor({ configuracion, rol }) {
    const navigate = useNavigate();
    const userId = localStorage.getItem('loggedUserId');
    const [eventos, setEventos] = useState([]);

    useEffect(() => {
        obtenerEventos();
    }, []);

    const obtenerEventos = async () => {
        try {
            const res = await axios.get(URL_CALENDARIO);
            if (Array.isArray(res.data)) {
                const tiposPreceptor = ['todos', 'todosA', 'todosD', 'todosE', 'todosT', 'todosM'];
                const eventosFiltrados = res.data.filter(evento => {
                    const esPropio = evento.creada_por == userId;
                    return esPropio || tiposPreceptor.includes(evento.tipo_recordatorio);
                });
                setEventos(eventosFiltrados);
            } else {
                setEventos([]);
            }
        } catch (err) {
            console.error('Error al obtener eventos preceptor:', err);
        }
    };

    const colorPrimary = configuracion.color_principal || '#014751';
    const colorSecondary = configuracion.color_secundario || '#0ac694';

    const accesos = [
        {
            titulo: 'Cargar Asistencia',
            descripcion: 'Registrar y administrar asistencia diaria de los estudiantes por curso.',
            icono: 'fa-clipboard-user',
            link: '/CargarAsistencia',
            colorGrad1: colorPrimary,
            colorGrad2: colorSecondary,
            badgeText: 'Asistencia'
        },
        {
            titulo: 'Inasistencias por Estudiante',
            descripcion: 'Buscar un estudiante por nombre, DNI o curso para ver su gráfica y detalle de asistencias.',
            icono: 'fa-user-check',
            link: '/InasistenciasEstudiante',
            colorGrad1: colorPrimary,
            colorGrad2: colorSecondary,
            badgeText: 'Detalle e Histórico'
        },
        {
            titulo: 'Reportes',
            descripcion: 'Consultar listas de estudiantes por curso e ingresar a las fichas de estudiantes.',
            icono: 'fa-chart-pie',
            link: '/Reportes',
            colorGrad1: colorSecondary,
            colorGrad2: colorPrimary,
            badgeText: 'Listados y Fichas'
        },
        {
            titulo: 'Calificaciones Generales',
            descripcion: 'Visualización general de calificaciones cargadas por curso e instancia.',
            icono: 'fa-star',
            link: '/CalificacionesGeneral',
            colorGrad1: colorSecondary,
            colorGrad2: colorPrimary,
            badgeText: 'Vista de Calificaciones'
        }
    ];

    return (
        <div className="container-principal">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="fw-bold text-dark m-0">
                    <i className="fa-solid fa-user-shield text-primary me-2"></i>
                    Panel de Preceptoría
                </h4>
            </div>

            <div className="row g-4">
                {/* Columna Izquierda: Accesos Directos (4 Módulos) */}
                <div className="col-12 col-lg-8">
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-4 bg-light">
                        <div className="card-header bg-white border-bottom-0 pt-4 pb-1 px-4">
                            <h5 className="fw-bold text-dark m-0">
                                <i className="fa-solid fa-grid-2 me-2 text-primary"></i>
                                Módulos Habilitados
                            </h5>
                            <p className="text-muted small mt-1 mb-0">Acceso rápido a las pantallas y funciones del preceptor</p>
                        </div>
                        <div className="card-body p-4">
                            <div className="row g-3">
                                {accesos.map((acc, index) => (
                                    <div key={index} className="col-12 col-md-6">
                                        <div 
                                            className="card h-100 border-0 shadow-sm hover-shadow-lg transition-all rounded-3 p-3 text-white"
                                            style={{
                                                background: `linear-gradient(135deg, ${acc.colorGrad1} 0%, ${acc.colorGrad2} 100%)`,
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => navigate(acc.link)}
                                        >
                                            <div className="card-body p-2 d-flex flex-column justify-content-between">
                                                <div>
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <span className="fs-2 text-white opacity-90">
                                                            <i className={`fa-solid ${acc.icono}`}></i>
                                                        </span>
                                                        <span className="badge bg-white text-dark opacity-90 rounded-pill px-3 py-1 small fw-bold">
                                                            {acc.badgeText}
                                                        </span>
                                                    </div>
                                                    <h5 className="fw-bold text-white mb-2">{acc.titulo}</h5>
                                                    <p className="text-white-50 small mb-3">{acc.descripcion}</p>
                                                </div>
                                                <div className="pt-2 border-top border-white border-opacity-25 d-flex justify-content-between align-items-center">
                                                    <span className="small fw-semibold text-white">Ingresar módulo</span>
                                                    <i className="fa-solid fa-arrow-right text-white"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Columna Derecha: Resumen de Agenda */}
                <div className="col-12 col-lg-4">
                    <div className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden">
                        <div className="card-header bg-white border-bottom-0 pt-4 pb-0 px-4">
                            <h6 className="fw-bold text-dark mb-0">
                                <i className="fa-regular fa-calendar-days text-primary me-2"></i>
                                Resumen de Agenda
                            </h6>
                        </div>
                        <div className="card-body p-4 pt-3">
                            <CalendarioResumenEventos eventos={eventos} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrincipalPreceptor;
